import { useState, useEffect } from "react";
import { appendStyleSheet, getEndpoint, getUrl, setCmsSeoData, getImageUrl, getImageSize, fetchAnchorValue } from "../../../common/utils.js";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SxProps, Theme } from "@mui/system";
import "./HomeFaq.css";
import bcrypt from "bcryptjs-react";
import Link from '@mui/material/Link';

HomeFaq.version = 1000;
HomeFaq.lang = "en";
HomeFaq.langs = ["en"];
HomeFaq.setLang = (lang: any) => {
  HomeFaq.lang = lang;
};

Object.defineProperty(HomeFaq, "name", {
  writable: true,
  value: "HomeFaq",
});

interface SeoSchema {
  "@context": string;
  "@type": string;
  mainEntity: {
    "@type": string;
    name: string;
    acceptedAnswer: {
      "@type": string;
      text: string;
    };
  }[];
}

export function HomeFaq(props: any) {


  const [seoPageData, setSeoPageData] = useState<any>({});
  const seoEndpoint = getEndpoint(props, "MAIN");
  const { mainHeadingColor, mainHeadingHref, mainHeading, bgColor, stripbgColor, anchorLinksValue } = props

  useEffect(() => {
    if (!seoEndpoint || !seoEndpoint?.isSSR || !seoEndpoint?.SSRDataObj) {
      fetchComponentDataSEO();
    }
  }, [seoEndpoint]);

  const fetchComponentDataSEO = () => {
    let headerAPI_SEO = getUrl(props, 0, false, "MAIN", true);
    let headerString2 = "?" + headerAPI_SEO.split("?")[1];
    headerString2 = bcrypt.hashSync(headerString2, 6);
    const headers2 = { "p-nonce": headerString2 };
    fetch(headerAPI_SEO, { headers: headers2 })
      .then((data) => data.json())
      .then((parsedData) => {
        setSeoPageData(parsedData.items[0]);
      })
      .catch(() => {
        //console.log("error");
      });
  };

  let styles = require("./HomeFaq.css");
  appendStyleSheet("HomeFaq", styles);

  if (
    seoEndpoint !== undefined &&
    seoEndpoint &&
    seoEndpoint.isSSR &&
    seoEndpoint.SSRDataObj &&
    seoPageData !== undefined &&
    seoPageData &&
    Object.keys(seoPageData).length === 0 &&
    seoEndpoint.SSRDataObj.items &&
    seoEndpoint.SSRDataObj.items.length != 0
  ) {
    setCmsSeoData(props, seoEndpoint.SSRDataObj.items[0], "ListView");
    setSeoPageData(seoEndpoint.SSRDataObj.items[0]);
  }

  const [expandedAccordion, setExpandedAccordion] = useState(0);
  const handleAccordionChange = (index: any) => {
    setExpandedAccordion(index);
  };

  // Define custom styles
  const accordionStyle: SxProps<Theme> = {
    backgroundColor: "#ECECEC",
    boxShadow: "none",
    border: "1px solid #ddd",
  };

  const accordionSummaryStyle: SxProps<Theme> = {
    backgroundColor: "#ECECEC",
    borderBottom: "1px solid #ddd",
  };

  const accordionDetailsStyle: SxProps<Theme> = {
    backgroundColor: "#fff",
  };


  const renderFaqList = (seoSchema: SeoSchema | null): React.ReactNode => {
    if (!seoSchema || !seoSchema.mainEntity || seoSchema.mainEntity.length === 0) {
      return null;
    }
    
    const limitedItems = seoSchema.mainEntity.slice(0, 4);
    return (
      <div className="ThemeThreeHomeAccoordianMainWrapper">
        <div className="ThemeThreeAccordianWrapper" style={{ backgroundColor: bgColor }}>
          <p className="ThemeThreeHomeAccoordianHeading">
          <Link href={mainHeadingHref} style={{color:mainHeadingColor}} target={fetchAnchorValue(anchorLinksValue, mainHeadingHref)}  >{mainHeading}</Link>
          </p>
          {limitedItems.map((item, index) => (
            <Accordion key={index} style={{ marginBottom: "20px", overflow: 'hidden' }}
              sx={accordionStyle} className="ThemeThreeAccordianHeaderWrapper" expanded={expandedAccordion === index}
              onChange={() => handleAccordionChange(index)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={accordionSummaryStyle}
                className="ThemeThreeAccordianHeader"
                style={{ backgroundColor: stripbgColor }} 
              >
                <Typography className='HomeFaqQuestions'>{item.name}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={accordionDetailsStyle} className="ThemeThreeAccordianDescriptionWrapper">
                <Typography className="ThemeThreeAccordianDescription">
                  {item.acceptedAnswer.text.replace(/<[^>]+>/g, '').length > 90 ? (
                    <div>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item.acceptedAnswer.text.substring(0, 90),
                        }}
                      />
                      {props.mainHeadingHref && (
                        <Link href={props.mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, props.mainHeadingHref)}>
                          Read More
                        </Link>
                      )}
                    </div>
                  ) : (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item.acceptedAnswer.text,
                      }}
                    />
                  )}
                </Typography>
              </AccordionDetails>

            </Accordion>
          ))}
        </div>
        <div className="ThemeThreeHomeAccordainImageWrapper">
          {seoPageData &&
            Object.keys(seoPageData).length > 0 &&
            !Array.isArray(seoPageData) &&
            seoPageData?.imageid &&
            seoPageData?.imageid.length != 0 && (
            <picture>
                <source media="(min-width: 768px)" srcSet={getImageUrl(seoPageData?.id,getImageSize(seoPageData?.imageid),588,603,"",false,props.CONSTANTS, '8')} />
                <source media="(max-width: 767px)" srcSet={getImageUrl(seoPageData?.id,getImageSize(seoPageData?.imageid),389,388,"",false,props.CONSTANTS, '8')} />
                <img alt={seoPageData?.hl} title={seoPageData?.hl} loading="lazy"/>
            </picture>
            )}
        </div>
      </div>
    );
  };

  return seoPageData &&
    Object.keys(seoPageData).length > 0 &&
    !Array.isArray(seoPageData) &&
    seoPageData?.seoSchema &&
    seoPageData?.seoSchema.length != 0 ? (
    <div>{renderFaqList(JSON.parse(seoPageData?.seoSchema))}</div>
  ) : (
    ""
  );
}
